export const GOOGLE_URL = 'https://www.google.com/search?q=back+market'
